import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { EndintroPage } from './endintro';

@NgModule({
  declarations: [
    EndintroPage,
  ],
  imports: [
    IonicPageModule.forChild(EndintroPage),
  ],
})
export class EndintroPageModule {}



// WEBPACK FOOTER //
// ./src/pages/endintro/endintro.module.ts